import { useEffect, useRef, useState } from "react";
import { MapPin, Tag, Landmark, Sparkles, Globe2 } from "lucide-react";
import { api } from "@/lib/api";

const ICON = { comune: MapPin, regione: Globe2, settore: Tag, termine: Sparkles, bando: Landmark };

/** Dropdown "termini simili" per qualsiasi campo di ricerca: comuni, settori, sinonimi, titoli bandi. */
export function SuggerimentiRicerca({ q, open, tipo = "tutto", onPick, testid = "sugg", className = "" }) {
  const [items, setItems] = useState([]);
  const last = useRef("");
  useEffect(() => {
    const v = (q || "").trim();
    if (!open || v.length < 2 || v === last.current) { if (v.length < 2) setItems([]); return; }
    const t = setTimeout(() => api.get("/public/ricerca/suggerisci", { params: { q: v, tipo } }).then((r) => { last.current = v; setItems(r.data.suggerimenti || []); }).catch(() => setItems([])), 200);
    return () => clearTimeout(t);
  }, [q, open, tipo]);
  if (!open || items.length === 0) return null;
  return (
    <ul className={`absolute left-0 top-full mt-1 z-40 w-full min-w-[280px] rounded-xl border border-slate-200 bg-white shadow-lg overflow-hidden ${className}`} data-testid={`${testid}-suggerimenti`} role="listbox">
      {items.map((o, i) => { const I = ICON[o.tipo] || Sparkles; return (
        <li key={o.tipo + o.testo + i}><button type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => onPick(o)} className="w-full text-left px-3 py-2 text-sm flex items-center gap-2 hover:bg-slate-50 text-slate-800" role="option" data-testid={`${testid}-opzione-${i}`}>
          <I size={13} className="text-[#0070BA] shrink-0" /><span className="truncate">{o.testo}</span><span className="ml-auto text-[11px] text-slate-400 shrink-0 truncate max-w-[45%]">{o.dettaglio}</span>
        </button></li>); })}
    </ul>
  );
}
